
window.addEventListener("DOMContentLoaded", function () {
    const sidebar = document.getElementById('sidebar');
    const collapser = document.getElementById('sidebar-collapser');

    window.openSidebar = () => {
        sidebar.classList.remove('collapsed');
        collapser.classList.add('nav-open');
    }

    window.openPanel = (panelId) => {
        window.openSidebar()
        document.querySelector('.panel-content.open')?.classList.remove('open');
        document.getElementById(panelId).querySelector('.panel-content').classList.add('open');
    }

    const panels = document.querySelectorAll('.lost-panel .panel-title');
    const filterPoi = document.querySelector('.filter-poi');
    const searchFromSourceBar = document.getElementById('poi-source-search');

    collapser.addEventListener('click', () => {
        const panelContentOpen = document.querySelector('.panel-content.open');
        if (panelContentOpen) {
            panelContentOpen.classList.remove('open');
        }
        if (searchFromSourceBar.classList.contains('hidden')) {
            searchFromSourceBar.classList.remove('hidden');
        }
        collapser.classList.remove('nav-open');
        sidebar.classList.add('collapsed');
        filterPoi.classList.toggle('collapsed');
    });

    panels.forEach((panel) => {
        panel.addEventListener('click', (e) => {
            const panelContent = panel.nextElementSibling;
            const panelContentOpen = document.querySelector('.panel-content.open');
            if (sidebar.classList.contains('collapsed')) {
                window.openSidebar();
            }
            if (panelContentOpen && panelContent !== panelContentOpen) {
                panelContentOpen.classList.toggle('open');
            }
            panelContent.classList.toggle('open');
        })
    });
});
